import { Component, Input } from '@angular/core';
import { AssignmentsEndingData } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-assignments-ending',
  templateUrl: './assignments-ending.component.html',
  styleUrls: ['./assignments-ending.component.scss'],
  standalone: false
})
export class AssignmentsEndingComponent {
  @Input() data!: AssignmentsEndingData;
}
